import store from '@/store';

export default {
    data() {
        return {
            boxWidth: 1846 * 2, // 原始宽度
            boxHeight: 1066 * 2, // 原始高度
            w: 0,
            h: 0
        };
    },
    beforeMount() {
        this.resizeWin();
        window.addEventListener('resize', this.resizeWin);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeWin);
    },
    methods: {
        resizeWin() {
            const maxProportion = this.boxWidth / this.boxHeight;
            const winWidth = document.documentElement.clientWidth;
            const winHeight = document.documentElement.clientHeight;
            const winProportion = winWidth / winHeight;

            if (maxProportion >= winProportion) {
                if (this.boxWidth > winWidth) {
                    this.w = winWidth;
                    this.h = (this.boxHeight * winWidth) / this.boxWidth;
                } else {
                    this.w = this.boxWidth;
                    this.h = this.boxHeight;
                }
            } else {
                if (this.boxHeight > winHeight) {
                    this.w = (this.boxWidth * winHeight) / this.boxHeight;
                    this.h = winHeight;
                } else {
                    this.w = this.boxWidth;
                    this.h = this.boxHeight;
                }
            }

            store.dispatch('app/setDeviceSize', {
                width: parseInt(this.w),
                height: parseInt(this.h)
            });

            this.reCalcRem();
        },
        reCalcRem() {
            if (!this.w) {
                return;
            }

            document.getElementsByTagName('html')[0].style.fontSize = 160 * (this.w / this.boxWidth) + 'px';
        }
    }
};